import { useState, useEffect } from 'react'
import {
  moveDownLeft,
  moveUpLeft,
  moveLeft,
  moveDownRight,
  moveUpRight,
  moveRight,
  moveUp,
  moveDown
} from './behaviours'
import { useKeypress } from './use-keypress'
import { useWorld } from './use-world'

export const useNavigate = (initialPosition, config) => {
  const cfg = {
    stride: 3,
    ...config
  }
  const [position, update] = useState(initialPosition)
  const [keys] = useKeypress()
  const { setTarget } = useWorld()

  useEffect(() => {
    const isMoving = keys.ArrowDown || keys.ArrowUp || keys.ArrowLeft || keys.ArrowRight
    if (isMoving) {
      setTarget()
    }
    if (keys.ArrowDown && keys.ArrowRight) {
      const nextPosition = moveDownRight(position, cfg.stride)
      update(nextPosition)
    } else if (keys.ArrowDown && keys.ArrowLeft) {
      const nextPosition = moveDownLeft(position, cfg.stride)
      update(nextPosition)
    } else if (keys.ArrowUp && keys.ArrowLeft) {
      const nextPosition = moveUpLeft(position, cfg.stride)
      update(nextPosition)
    } else if (keys.ArrowUp && keys.ArrowRight) {
      const nextPosition = moveUpRight(position, cfg.stride)
      update(nextPosition)
    } else if (keys.ArrowDown) {
      const nextPosition = moveDown(position, cfg.stride)
      update(nextPosition)
    } else if (keys.ArrowLeft) {
      const nextPosition = moveLeft(position, cfg.stride)
      update(nextPosition)
    } else if (keys.ArrowRight) {
      const nextPosition = moveRight(position, cfg.stride)
      update(nextPosition)
    } else if (keys.ArrowUp) {
      const nextPosition = moveUp(position, cfg.stride)
      update(nextPosition)
    }
  }, [keys])

  const getPosition = (ev) => {
    setTarget(ev)
  }

  // useEffect(() => {
  //  document.addEventListener("click", getPosition);
  //  return () => document.removeEventListener("click", getPosition);
  // }, []);

  return [position, update]
}
